module.exports = __webpack_public_path__ + "static/nesting-f559d1d3f8f05bf3c9c23e6df39e2316.png";